/* Casa de Diciembre · upsell preseleccionado del cajón.
   Shrine solo añade el upsell marcado como "preseleccionado" al cargar la página.
   Este script lo añade también justo después de añadir un producto desde la ficha,
   pero SOLO cuando ese producto es el primero del carrito (si el cliente lo quita, no se vuelve a meter). */
(function () {
  var busy = false;
  function sectionsToRender(drawer) {
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map(function (s) { return s.id || s.section; }).filter(Boolean);
      }
    } catch (e) {}
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function preselected() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-drawer cart-drawer-upsell[data-selected="true"][data-toggle="true"][data-id]'));
  }
  function run(data) {
    if (busy) return;
    if (data && data.source && data.source !== 'product-form') return;
    var ups = preselected();
    if (!ups.length) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (i) { inCart[String(i.variant_id)] = true; });
        var missing = ups.map(function (u) { return u.dataset.id; }).filter(function (id) { return !inCart[id]; });
        // Solo cuando el carrito acaba de estrenarse: la única línea es la que se acaba de añadir.
        var otherQty = 0;
        // Oferta packs: las líneas regalo (_gift_for, ver cdd-gift-sync.js) no cuentan; el pack + sus regalos = 1 producto.
        (cart.items || []).forEach(function (i) {
          if (i.properties && i.properties._gift_for) return;
          if (!ups.some(function (u) { return u.dataset.id === String(i.variant_id); })) otherQty += i.quantity;
        });
        if (!missing.length || otherQty !== 1) { busy = false; return; }
        var drawer = document.querySelector('cart-drawer');
        var sections = sectionsToRender(drawer);
        return fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: missing.map(function (id) { return { id: Number(id), quantity: 1 }; }), sections: sections.join(','), sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (resp) {
          busy = false;
          if (!resp || resp.status) return;
          if (drawer && typeof drawer.renderContents === 'function') {
            try { drawer.renderContents(resp); } catch (e) {}
          }
        });
      })
      .catch(function () { busy = false; });
  }
  var subscribed = false;
  function init() {
    if (subscribed) return;
    var sub = (typeof subscribe === 'function') ? subscribe : window.subscribe;
    if (typeof sub !== 'function') return;
    var EV = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
    sub(EV, function (data) { setTimeout(function () { run(data); }, 150); });
    subscribed = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
